type Config = {
  AnalyticsEvent: {
    0: string
    1: string
    2: string
    3: string
    4: string
    5: string
    Back: string
    CheckVideo: string
    FinishSound: string
    PlaySound: string
    StripeContract: string
  }
  Icon: {
    Back: string
    Burn: string
    Distance: string
    Incline: string
    Level: string
    NoteWhite: string
    Note: string
    Play: string
    Speed: string
    Time: string
    Trial: string
  }
  ImageFile: {
    CheckVideo: string
    Close: string
    GoPlayStore: string
    GoStripePurchase: string
    HomeCover: string
    Next: string
    Prev: string
    Start: string
    Stop: string
  }
  PageUrl: {
    Content: string
    Sound: string
  }
  StripeContractUrl: string
}

const Config: Config = {
  AnalyticsEvent: {
    0: "RhythmWalk",
    1: "WarmupRunning",
    2: "IndoorBike",
    3: "CrossTrainer",
    4: "Stretch",
    5: "AbdominalMuscle",
    Back: "Back",
    CheckVideo: "CheckVideo",
    FinishSound: "FinishSound",
    PlaySound: "PlaySound",
    StripeContract: "StripeContract",
  },
  Icon: {
    Back: "back-icon.png",
    Burn: "burn-icon.png",
    Distance: "distance-icon.png",
    Incline: "incline-icon.png",
    Level: "level-icon.png",
    NoteWhite: "note-icon-white.png",
    Note: "note-icon.png",
    Play: "play-icon.png",
    Speed: "speed-icon.png",
    Time: "time-icon.png",
    Trial: "trial-icon.png",
  },
  ImageFile: {
    CheckVideo: "check-video.png",
    Close: "close.png",
    GoPlayStore: "go-play-store.png",
    GoStripePurchase: "go-purchase-stripe.png",
    HomeCover: "home_cover.png",
    Next: "navi-right.png",
    Prev: "navi-left.png",
    Start: "start.png",
    Stop: "stop.png",
  },
  PageUrl: {
    Content: "/content/",
    Sound: "/sound/",
  },
  StripeContractUrl: "https://beatfit.biz/s-re",
}

export default Config
